import type { ReactNode } from "react";

import { DropdownMenu } from "@radix-ui/themes";

import {
  WORKSPACE_TEMPLATE_OPTIONS,
  type WorkspaceTemplateId,
} from "./shared/workspace/workspaceTemplates";

export interface NewWorkspaceMenuPresentationProps {
  trigger: ReactNode;
  align?: "start" | "end";
  onCreateWorkspace: (templateId?: WorkspaceTemplateId) => void;
}

export const NewWorkspaceMenuPresentation = ({
  trigger,
  align = "start",
  onCreateWorkspace,
}: NewWorkspaceMenuPresentationProps) => (
  <DropdownMenu.Root>
    {trigger}
    <DropdownMenu.Content align={align} size="1" variant="soft">
      <DropdownMenu.Item onSelect={() => onCreateWorkspace()}>
        Blank Workspace
      </DropdownMenu.Item>
      <DropdownMenu.Sub>
        <DropdownMenu.SubTrigger>Template Workspace</DropdownMenu.SubTrigger>
        {/* Radix applies Content chrome props at runtime but omits them from
            SubContent's public type. */}
        {/* @ts-expect-error -- `size` and `variant` are runtime-supported. */}
        <DropdownMenu.SubContent size="1" variant="soft">
          {WORKSPACE_TEMPLATE_OPTIONS.map(({ id, label }) => (
            <DropdownMenu.Item key={id} onSelect={() => onCreateWorkspace(id)}>
              {label}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.SubContent>
      </DropdownMenu.Sub>
    </DropdownMenu.Content>
  </DropdownMenu.Root>
);
